"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
var _jsxruntime = require("react/jsx-runtime");
var _utils = require("@collinsonx/utils");
var _icons = require("../../assets/icons");
var _core = require("@mantine/core");
var _outletSubtitlemodulecss = /*#__PURE__*/ _interop_require_default(require("../../../dist/assets/components/outletSubtitle.module.css"));
var _clsx = /*#__PURE__*/ _interop_require_default(require("clsx"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var LocationIcon = function(param) {
    var type = param.type;
    var _obj;
    var IconComponent = type ? (_obj = {}, _obj[_utils.LocationType.Airport] = _icons.AirportLocationIcon, _obj[_utils.LocationType.FerryStation] = _icons.FerryLocationIcon, _obj[_utils.LocationType.RailwayStation] = _icons.RailwayLocationIcon, _obj)[type] : undefined;
    return IconComponent ? /*#__PURE__*/ (0, _jsxruntime.jsx)(IconComponent, {
        height: "22",
        width: "22"
    }) : null;
};
var OutletSubtitle = function(param) {
    var location = param.location, classNames = param.classNames;
    return /*#__PURE__*/ (0, _jsxruntime.jsxs)(_core.Text, {
        className: (0, _clsx.default)(_outletSubtitlemodulecss.default.subtitle, classNames == null ? void 0 : classNames.subtitle),
        "data-testid": "outlet-subtitle",
        children: [
            /*#__PURE__*/ (0, _jsxruntime.jsx)("div", {
                className: (0, _clsx.default)(_outletSubtitlemodulecss.default.locationIconWrapper, classNames == null ? void 0 : classNames.locationIconWrapper),
                "data-testid": "subtitle-img",
                children: /*#__PURE__*/ (0, _jsxruntime.jsx)(LocationIcon, {
                    type: location == null ? void 0 : location.type
                })
            }),
            [
                location == null ? void 0 : location.city,
                location == null ? void 0 : location.code,
                location == null ? void 0 : location.name,
                (location == null ? void 0 : location.terminal) && "Terminal " + (location == null ? void 0 : location.terminal)
            ].filter(Boolean).join(" • ")
        ]
    });
};
var _default = OutletSubtitle;
